export enum AppPaths {
    Auth = 'auth',
    Identity = 'identity',
    UsernameLost = 'usernameLost',
    PasswordLost = 'passwordLost',
    CodeLost = 'codeLost',
    LockIdentity = 'lockIdentity',
    PasswordReset = 'passwordReset',
    PasswordModify = 'passwordModify',
    EmailVerify = 'emailVerify',
    Activate = 'activate',
}